import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ShipStationOrder } from 'src/app/models/fbmOrders.model';

@Injectable({
  providedIn: 'root'
})
export class ShipStationService {

  private headers = new HttpHeaders({ "Content-Type": "application/json" });
  options = { headers: this.headers };
  baseurl = "api/shipstation/";

  constructor(private http: HttpClient) { }

  getOrdersShipingDetails(orderNumber: string, account: string = "shipstation",store) {
    return this.http.post(
      `${this.baseurl}GetOrderByOrderNumber`,
      { orderNumber, account,store },
      this.options);
  }

  getOrdersShipingRate(shipStationOrder: ShipStationOrder, fromPostalCode: string, account: string = "shipstation") {
    let carrierRateRquest = {
      carrierCode: shipStationOrder?.carrierCode,
      serviceCode: shipStationOrder?.serviceCode,
      packageCode: shipStationOrder?.packageCode,
      toState: shipStationOrder?.shipTo.state,
      toCountry: shipStationOrder?.shipTo.country,
      toPostalCode: shipStationOrder?.shipTo.postalCode,
      toCity: shipStationOrder?.shipTo.city,
      weight: shipStationOrder?.weight,
      dimensions: shipStationOrder?.dimensions,
      fromPostalCode: fromPostalCode
    }
    const payload = { carrierRateRquest, account }
    return this.http.post(
      `${this.baseurl}GetShippingCarrierRate`,
      payload,
      this.options);
  }

  printLabelUsingUrl(shipStationOrder: ShipStationOrder, orderno: string, account: string = "shipstation") {

    let data = {
      account: account,
      orderId: shipStationOrder.orderId,
      carrierCode: shipStationOrder.carrierCode,
      serviceCode: shipStationOrder.serviceCode,
      shipDate: shipStationOrder.shipByDate,
      weight: shipStationOrder.weight,
      dimensions: shipStationOrder.dimensions,
      insuranceOptions: shipStationOrder.insuranceOptions,
      internationalOptions: shipStationOrder.internationalOptions,
      advancedOptions: shipStationOrder.advancedOptions,
      testLabel: false,
      orderNo: orderno
    }
    return this.http.post(
      `${this.baseurl}PrintLabel`,
      { ...data },
      this.options);
  }

  printLabelFromLocal(orderNo: string): Observable<any> {
    return this.http.post(`${this.baseurl}PrintLabelFromLocal`, { orderNo }, this.options);
  }

  getShipstationCarrierService(account: string = "shipstation"){
    return this.http.get(`${this.baseurl}/GetShipstationCarrierService?Account=${account}`,this.options);
  }

  getShipstationCarrierPackage(ShipStationCarrierId){
    return this.http.get(`${this.baseurl}/GetShipstationCarrierPackage?ShipStationCarrierId=${ShipStationCarrierId}`,this.options);
  }

  downloadPackageForCarrier(account:string = "shipstation"){
    return this.http.post(`${this.baseurl}DownloadPackageForCarrier`, { account }, this.options);
  }
  
  downloadServiceForCarrier(account:string = "shipstation"){
    return this.http.post(`${this.baseurl}DownloadServiceForCarrier`, { account }, this.options);
  }

  refreshShipStationCarrier(account:string = "shipstation"){
    return this.http.get(`${this.baseurl}/RefreshShipStationCarrier?Account=${account}`,this.options);
  }

  PrintFbmLabelBulk(payload){
    return this.http.post(`${this.baseurl}PrintFbmLabelBulk`,{...payload}, this.options);
  }

  PrintPackingSlipBulk(payload){
    return this.http.post(`${this.baseurl}PrintPackingSlipBulk`,{...payload}, this.options);
  }
}
